import PropTypes,{InferProps} from 'prop-types'

export const SankeyNodePropTypes = {
  // identification
  idNode: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,

  parent_name : PropTypes.string,
  //- level attributes
  dimensions : PropTypes.objectOf(
    PropTypes.shape({
      parent_name : PropTypes.string,
      level       : PropTypes.number,
    }).isRequired
  ).isRequired,

  display: PropTypes.bool.isRequired,

  // display attributes
  node_visible: PropTypes.bool.isRequired,
  shape_visible: PropTypes.bool.isRequired,
  label_visible: PropTypes.bool.isRequired,
  color: PropTypes.string.isRequired,
  colorFavoriteTags:PropTypes.objectOf(PropTypes.shape({
    tag_associated:PropTypes.string.isRequired,
    color:PropTypes.string
  }).isRequired
  ).isRequired,

  nodeParameter:PropTypes.string.isRequired,

  // geometry
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  x_label: PropTypes.number,
  y_label: PropTypes.number,

  tooltip_text: PropTypes.string,
  definition: PropTypes.string,

  // topology
  inputLinksId: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  outputLinksId: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,

  // semantic
  type: PropTypes.oneOf(['product', 'sector']),
  tags: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string.isRequired).isRequired).isRequired,

  trade_width: PropTypes.number.isRequired,
  trade_height: PropTypes.number.isRequired,
  trade_close: PropTypes.bool.isRequired
}

export type SankeyNode = InferProps<typeof SankeyNodePropTypes>

export const SankeyLinkPropTypes = {
  // identification
  idLink: PropTypes.string.isRequired,
  idSource: PropTypes.string.isRequired,
  idTarget: PropTypes.string.isRequired,

  // type of link
  recycling: PropTypes.bool,
  orientation: PropTypes.string.isRequired,
  arrow: PropTypes.bool.isRequired,

  // display_attribute
  label_position: PropTypes.string.isRequired,
  label_on_path: PropTypes.bool.isRequired,
  label_visible: PropTypes.bool.isRequired,
  text_color: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  //visible: PropTypes.bool.isRequired,

  // value
  value: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  display_value: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,

  tooltip_text: PropTypes.string,

  // geometry
  x_label: PropTypes.number,
  y_label: PropTypes.number,

  left_horiz_shift  : PropTypes.number.isRequired,
  right_horiz_shift : PropTypes.number.isRequired,
  vert_shift        : PropTypes.number.isRequired,
  shift_gap         : PropTypes.number.isRequired,

  curvature: PropTypes.number.isRequired,
  curved: PropTypes.bool.isRequired,

  tags: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string.isRequired).isRequired).isRequired,

  natural_unit         : PropTypes.string,
  conv                 : PropTypes.arrayOf(PropTypes.number.isRequired),

  data_value            : PropTypes.arrayOf(PropTypes.number.isRequired),
  data_source           : PropTypes.arrayOf(PropTypes.string.isRequired),
  data_period           : PropTypes.arrayOf(PropTypes.string.isRequired),

  tooltips             : PropTypes.arrayOf(PropTypes.string),

  mini                 : PropTypes.arrayOf(PropTypes.number.isRequired),
  maxi                 : PropTypes.arrayOf(PropTypes.number.isRequired)
}

export type SankeyLink = InferProps<typeof SankeyLinkPropTypes>

export const TagsGroupPropTypes = {
  group_name: PropTypes.string.isRequired,
  show_legend: PropTypes.bool.isRequired,
  tags:PropTypes.objectOf(PropTypes.shape({
    name:PropTypes.string.isRequired,
    color:PropTypes.string,
    selected:PropTypes.bool.isRequired,
  }).isRequired).isRequired,
  banner:PropTypes.string.isRequired
}
export type TagsGroup = InferProps<typeof TagsGroupPropTypes>

export const TagsCatalogPropTypes = PropTypes.objectOf(PropTypes.shape(TagsGroupPropTypes).isRequired).isRequired
export type TagsCatalog = InferProps<typeof TagsCatalogPropTypes>

export const SankeyDataPropTypes = {
  version: PropTypes.string.isRequired,
  file_path: PropTypes.string.isRequired,
  node_width: PropTypes.number.isRequired,
  user_scale: PropTypes.number.isRequired,
  //height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  h_space: PropTypes.number.isRequired,
  v_space: PropTypes.number.isRequired,
  left_shift: PropTypes.number.isRequired,
  right_shift: PropTypes.number.isRequired,
  max_shift: PropTypes.number.isRequired,
  legend_position: PropTypes.arrayOf( PropTypes.number.isRequired).isRequired,

  nodes: PropTypes.objectOf(PropTypes.shape(SankeyNodePropTypes).isRequired).isRequired,
  links: PropTypes.objectOf(PropTypes.shape(SankeyLinkPropTypes).isRequired).isRequired,

  display_style : PropTypes.shape({
    font_size: PropTypes.number.isRequired,
    sector_uppercase: PropTypes.bool.isRequired,
    sector_bold: PropTypes.bool.isRequired,
    sector_italic: PropTypes.bool.isRequired,
    product_uppercase: PropTypes.bool.isRequired,
    product_bold: PropTypes.bool.isRequired,
    product_italic: PropTypes.bool.isRequired,
    unit: PropTypes.bool.isRequired,
    filter: PropTypes.number.isRequired,
    filter_label: PropTypes.number.isRequired,
    global_curvature: PropTypes.number.isRequired,
    null_flux: PropTypes.bool.isRequired
  }).isRequired,

  static_sankey : PropTypes.bool.isRequired,

  tags_catalog: TagsCatalogPropTypes,
  tags_group_idx: PropTypes.number.isRequired,
  tag_idx: PropTypes.number.isRequired,
  node_idx: PropTypes.number.isRequired,
  link_idx: PropTypes.number.isRequired,

  tooltip_names : PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  tooltips : PropTypes.arrayOf(PropTypes.string.isRequired),

  units_names : PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  diagrams_selector_label: PropTypes.string,
  animation_tooltips : PropTypes.any,
  show_uncert: PropTypes.bool,

  default_tooltip : PropTypes.bool.isRequired,

  trade : PropTypes.string,
  trade_sectors : PropTypes.arrayOf(PropTypes.string.isRequired),
  trade_hspace: PropTypes.number.isRequired,
  trade_close_hspace: PropTypes.number.isRequired,
  trade_close_vspace: PropTypes.number.isRequired,
  trade_left_shift: PropTypes.number.isRequired,
  trade_right_shift: PropTypes.number.isRequired,
  trade_max_shift: PropTypes.number.isRequired
}

export type SankeyData = InferProps<typeof SankeyDataPropTypes>

export interface SankeyMenuState {
  processing: boolean
  show_excel_dialog:boolean
  show_publish_dialog:boolean
}

export interface PublishModalState {
  file_path : string
}

export interface ExcelModalState {
  sheet : string
}

export interface SankeyAppState {
  show_readme : boolean
  show_legend : boolean
  show_entry : boolean
  
  advanced: boolean
  unit: string
  current_step: number

  subchain: string[]
  default_tooltip: boolean
  flux_types: string[]
  sous_filiere: string[]
  main_color : string

  data : SankeyData

  legend_average? : string
  legend_uncert? : string
  welcome_text? : string
  help_text?: string

  animation: boolean
}

